import { FC } from 'react';

const RadioIcon: FC = (props) => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="15" cy="15" r="14.5" fill="white" stroke="#B2B2B2"/>
    </svg>
  );
};

export default RadioIcon;
